<div class="line">
  <mat-icon (click)="openDialog()" class="material-icons-outlined"
    >delete</mat-icon
  >
</div>
